// extracted by mini-css-extract-plugin
export var awards = "awards-module--awards--uRax8";
export var box = "awards-module--box--FNrYH";
export var pinkStar = "awards-module--pinkStar--VcOBc";
export var ribbon = "awards-module--ribbon--Zpw83";
export var sbShowMain = "awards-module--sb-show-main--3wZPI";
export var star = "awards-module--star--gQOmH";
export var stars = "awards-module--stars--VWN7N";
export var wrapper = "awards-module--wrapper--LXH9A";